module.exports = __webpack_public_path__ + "img/danger.bab9f96.svg";